import "./App.css";

import MenuCard from "./components/MenuCard";

async function getMenu() {
    const response = await fetch("data/menu.json");
    return await response.json();
}

const menu = await getMenu();

function HomeApp() {
    return (
        <div className="m-4 grid grid-cols-[repeat(auto-fill,23rem)] gap-4 items-start justify-center">
            {Object.entries(menu)
                .sort(([, a], [, b]) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
                .map(([key, menuItem]) => (
                    <MenuCard key={key} menuItem={menuItem}/>
                ))}
        </div>
    );
}

export default HomeApp;
